import { Injectable, signal } from '@angular/core';

export interface PageBreadcrumbIcon {
  logoUrl?: string | null;
  initials?: string;
  color?: string;
}

export interface PageBreadcrumbCrumb {
  label: string;
  onBack: () => void;
  icon?: PageBreadcrumbIcon;
}

// Lets a page push a "drill-in" crumb (e.g. a selected site/project) up to the
// shared dashboard layout header, without any route change. Each page that
// calls setCrumb() owns clearing it — on its own back action, and in
// ngOnDestroy() as a safety net if the user navigates away mid-drill-down.
@Injectable({ providedIn: 'root' })
export class PageBreadcrumbService {
  private readonly _crumb = signal<PageBreadcrumbCrumb | null>(null);

  public readonly crumb = this._crumb.asReadonly();

  public setCrumb(crumb: PageBreadcrumbCrumb): void {
    this._crumb.set(crumb);
  }

  public clear(): void {
    this._crumb.set(null);
  }
}
